module.exports = __webpack_public_path__ + "img/Quality_assurance.c8404adf.jpg";